
import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";

export const useExistingStartupAccount = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const [checkingExisting, setCheckingExisting] = useState(true);
  const [hasExistingAccount, setHasExistingAccount] = useState(false);

  useEffect(() => {
    if (user) {
      checkExistingAccount();
    }
  }, [user]);

  const checkExistingAccount = async () => {
    try {
      console.log("Checking for existing startup account for user:", user?.id);
      
      const { data, error } = await supabase
        .from("startup_accounts")
        .select("id, status")
        .eq("user_id", user?.id)
        .maybeSingle();

      console.log("Existing account check result:", { data, error });

      if (error && error.code !== 'PGRST116') {
        console.error("Error checking existing account:", error);
        toast({
          title: "Error",
          description: "Failed to check existing applications",
          variant: "destructive"
        });
      } else if (data) {
        console.log("Found existing startup account:", data);
        setHasExistingAccount(true);
        toast({
          title: "Application Already Exists",
          description: `You already have a startup application with status: ${data.status}`,
          variant: "destructive"
        });
      }
    } catch (error) {
      console.error("Error checking existing account:", error);
      toast({
        title: "Error",
        description: "Failed to check existing applications",
        variant: "destructive"
      });
    } finally {
      setCheckingExisting(false);
    }
  };

  return {
    checkingExisting,
    hasExistingAccount,
    setHasExistingAccount
  };
};
